import React from 'react';
import GlobalModule from './components/Modules/GlobalModule';
import 'leaflet/dist/leaflet.css';
import "./App.css";
import Router from './Router';
import Proximamente from './components/Layout/Proximamente/Proximamente';

const App = () => {
  return (
    <GlobalModule>
        <Router />
      {/* <Proximamente /> */}
    </GlobalModule>
  )
}

export default App